// not launched
export const NOT_PURCHASED = "Not Purchased";

export const ALL = "All";

// in progress steps
export const IN_PROGRESS = "In Progress";

// action pending steps
export const INFORMATION_REQUIRED = "Information Required";
export const ADD_DETAILS = "Add Details";

// completed steps
export const SUCCESSFULLY_FILED = "Successfully Filed";
export const COMPLETED = "Completed";
export const AMENDMENT_FILED = "Amendment Filed";

export const ACTION_PENDING = "Action Pending";

export const FILING_IN_ADD_DETAILS_CUSTOM_TYPE =
  "FILING_IN_ADD_DETAILS_CUSTOM_TYPE";
export const CART = "CART";
export const INVOICES_DUE = "INVOICES_DUE";
